
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inspiracija/[slug]",
      function () {
        return require("private-next-pages/inspiracija/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inspiracija/[slug]"])
      });
    }
  